import axios from "../interceptors/axios";

export class PasswordServer {

    forgot = async (data) => {
        try {
            const response = await axios.post("/api/forgot-password", data);            
            return {...response};
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
            console.error("Status:", error.response.status);
            console.error("Data:", error.response.data);
            return {...error.response};
            } else {
            console.error("Error Message:", error.message);
            }
            throw error;
        }
    };

    reset = async (data) => {
        try {
            const response = await axios.post("/api/reset-password", data);
            return {...response};
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
            console.error("Status:", error.response.status);
            console.error("Data:", error.response.data);
            return {...error.response};
        } else {
            console.error("Error Message:", error.message);
            }
            throw error;
        }
    };

}
